// Footer.jsx
import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaMapMarkerAlt, FaPhone, FaEnvelope, FaGlobe } from "react-icons/fa";
import "./Footer.css"; // agar CSS alag file me rakhi hai
import { BASE_URL } from "../Base_url/Base_Url";
import { useGlobalContext } from "../Base_url/GobelContaxt";

const Footer = () => {
  const { segments, loading, error, contactData } = useGlobalContext();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-container">
          <div className="footer-column footer-about">
            <h3>About Us</h3>
            <p>
              Call For Cabs offers reliable taxi, tempo traveller, and bus
              rental services across Rajasthan. From local rides to outstation tours,
              enjoy safe, comfortable, and affordable travel with professional drivers and 24/7 support.
            </p>
            <div className="social-links">
              <a href="#"><FaFacebookF /></a>
              <a href="#"><FaTwitter /></a>
              <a href="#"><FaInstagram /></a>
              <a href="#"><FaLinkedinIn /></a>
            </div>
          </div>

          <div className="footer-column footer-links">
            <h3>Quick Links</h3>
            <ul>

              {
                segments.map((link) =>
                  <li><a href={`/${link.slug}`}>
                    <i className="fas fa-angle-right me-2" /> {link.name}
                  </a>
                  </li>
                )
              }




            </ul>
          </div>

          <div className="footer-column footer-links">
            <h3>Our Support</h3>
            <ul>
              <li><a href="/Aboutus">About us </a></li>
              <li><a href="contact.html">Contact Us</a></li>

            </ul>
          </div>

          <div className="footer-column footer-contact">
            <h3>Contact Us</h3>
            <ul>
              <li><FaMapMarkerAlt /> Jaipur , Rajshthan</li>
              <li><FaPhone />+91 9116839808</li>
              <li><FaEnvelope /> callforcab@gmail.com</li>
              <li>< FaGlobe />https://callforcabs.com</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; Copyright Call for Cabs All Rights Reserved | Designed & Developed by Auratech India</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
